import React, { useState, useEffect } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

const GOOGLE_MAPS_LIBRARIES = ["places"];

const MyComponent = ({ newlatlon, replacemap, input }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "YOUR_API_KEY",
    libraries: GOOGLE_MAPS_LIBRARIES,
  });

  const [map, setMap] = useState(null);
  const [containerStyle, setContainerStyle] = useState({
    width: "100%",
    height: "500px",
  });

  const [center, setCenter] = useState({
    lat: 37.772,
    lng: -122.214,
  });

  useEffect(() => {
    if (input.value) {
      setCenter({
        lat: Number(input.value.lat),
        lng: Number(input.value.lon),
      });
    }
  }, [input.value]);



  const onLoad = React.useCallback(
    function callback(map) {
      const bounds = new window.google.maps.LatLngBounds(center);
      map.fitBounds(bounds);

      setMap(map);
    },
    [center]
  );

  const onLoadMarker = (marker) => {
    if (marker && marker.latLng) {
      var lng = marker.latLng.lng();
      var lat = marker.latLng.lat();
  
      replacemap({ lat: lat, lon: lng, inputname: input.name });
    }
  };

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);

  if (loadError) {
    return (
      <div style={containerStyle} className="d-flex align-items-center justify-content-center bg-light border">
        <div className="text-center">
          <i className="fa fa-map-marker fa-3x text-muted mb-3"></i>
          <h5 className="text-muted">Google Maps niet beschikbaar</h5>
          <p className="text-muted">Kaart kan niet worden geladen. Controleer je internetverbinding of neem contact op met de beheerder.</p>
        </div>
      </div>
    );
  }

  if (!isLoaded) {
    return (
      <div style={containerStyle} className="d-flex align-items-center justify-content-center bg-light border">
        <div className="text-center">
          <i className="fa fa-spinner fa-spin fa-2x text-muted mb-3"></i>
          <h5 className="text-muted">Kaart laden...</h5>
        </div>
      </div>
    );
  }

  return (
    <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={16} onUnmount={onUnmount}>
      <Marker onLoad={onLoadMarker} position={center} draggable={true} onDragEnd={onLoadMarker} />
      {/* Child components, such as markers, info windows, etc. */}
      <></>
    </GoogleMap>
  );
};

export default React.memo(MyComponent);
